module.exports = __webpack_public_path__ + "img/eyes.cb4a9abe.gif";